import select from 'dom-select';
import { getCookie, setCookie } from '@lib/cookies';

const COOKIE_NAME = 'vb_ga';

export const GlobalAlerts = (el) => {
  const ui = {
    el,
    globalAlerts: select('.global-alerts')
  };

  ui.toggle = document.querySelector('.global-alerts-close');

  const addEvents = () => {
    ui.toggle.addEventListener('click', () => {
      ui.globalAlerts.classList.add('is-hidden');
      ui.globalAlerts.setAttribute('aria-expanded', false);

      var alertTimestamp = ui.globalAlerts.getAttribute('data-alert-timestamp');
      setCookie(COOKIE_NAME, alertTimestamp, 30);
    });
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalAlerts;